<template>
  <div class="p-col-12">
    <page-header title="forms.timeline-predefinition.title"/>
    <form @submit.prevent="save">

      <card :header="$t('forms.timeline-predefinition.card-title')" class="p-col-12">
        <coff-input-text v-model="form.name" label="forms.timeline-predefinition.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
        <coff-input-text v-if="form.id" v-model="form.code" :disable="true" label="forms.timeline-predefinition.code" class="p-col-12 p-md-6 p-lg-4"/>
        <coff-input-radio v-model="form.active" @update="forceUpdateField('active', $event)" :options="options" label="forms.timeline-predefinition.active" class="p-col-12 p-md-4 p-lg-2" :error="validation.active"/>
        <coff-input-text-editor v-model="form.content" label="forms.timeline-predefinition.content" class="p-col-12"/>
        <div class="p-col-12">
          <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
        </div>
      </card>

    </form>
  </div>
</template>

<script>

import ValidationUtils from "@/utils/ValidationUtils";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import TimelinePredefinitionBusiness from "@/business/TimelinePredefinitionBusiness";
import PageHeader from "@/components/page/PageHeader";
import EventBus from "@/commons/EventBus";

export default {
  name: "TimelinePredefinitionForm",
  components: {PageHeader},
  data(){
    return {
      form: {},
      validation: {
        name: false,
        active: false,
        content: false,
      },
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
    }
  },

  async mounted(){
    const id = this.$route.params.id;
    if(id){
      EventBus.loadingPage(true);
      this.form =  {... await TimelinePredefinitionBusiness.getById(id)};
      EventBus.loadingPage(false);
    }
  },

  methods: {

    async save(){
      this.validation = ValidationUtils.basicValidation(this.validation, this.form);
      if(!this.validation.erros){
        const response = await TimelinePredefinitionBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.form.id = response.id;
          ToastMessageBusiness.showSuccess();
        }
      }
    },

    forceUpdateField(field, value){
      this.$set(this.form, field, value);
    },

  }

}
</script>

<style scoped>

</style>